import {AggregatedSestData, MaintenanceInfo} from '@di-shared/api/di/__generated';

interface SDKWarningLightData {
  sestCode: string;
  isSDKWarningLight: boolean;
}

type AggregatedSestDataWithSDKInfo = AggregatedSestData & {isSDKWarningLight: boolean};

export function mergeWithSDKDataAndSort(data: AggregatedSestData[], sdkData?: SDKWarningLightData[]) {
  const dataWithSDKInfo = data.map((item) => {
    const matchedSDKData = sdkData?.find((sdk) => sdk.sestCode === item.sestCode);
    return {
      ...item,
      isSDKWarningLight: matchedSDKData?.isSDKWarningLight ?? false,
    };
  });

  return dataWithSDKInfo.sort(sortByExchangeCycle);
}

export function getBadges(data: AggregatedSestData[], sdkData?: SDKWarningLightData[]) {
  const sortedDataWithSDK = mergeWithSDKDataAndSort(data, sdkData);
  return sortedDataWithSDK.map(({sestName, maintenanceInfos, isSDKWarningLight}) => ({
    title: sestName,
    isWarning: maintenanceInfos.some(({status}) => status === MaintenanceInfo.status.REQUIRED || isSDKWarningLight),
  }));
}

/**
 * • 교환 주기 도래 기준
 * • 주행 거리 기반 : 잔여 거리 1,000km 이하
 * • 교환 기간 기반 : 남은 일수 30일 이하
 * sorting
 * 0순위: isSDKWarningLight
 * 1순위: replacementStatus === 'REQUIRED'
 * 2순위: RECOMMENDED
 * 3순위: GOOD
 * 4순위 order
 */

function sortByExchangeCycle(a: AggregatedSestDataWithSDKInfo, b: AggregatedSestDataWithSDKInfo) {
  function getStatusExists(item: AggregatedSestDataWithSDKInfo, targetStatus: MaintenanceInfo.status) {
    return item.maintenanceInfos.some(({status}) => status === targetStatus);
  }

  /**
   * a와 b의 isSDKWarningLight값이 다를 때
   * a.isSDKWarningLight가 true 이면 `-1`을 반환 (a가 앞으로)
   */
  if (a.isSDKWarningLight !== b.isSDKWarningLight) {
    return a.isSDKWarningLight ? -1 : 1;
  }

  const priorityStatuses = [MaintenanceInfo.status.REQUIRED, MaintenanceInfo.status.RECOMMENDED, MaintenanceInfo.status.GOOD] as const;

  for (const status of priorityStatuses) {
    const isStatusA = getStatusExists(a, status);
    const isStatusB = getStatusExists(b, status);

    if (isStatusA !== isStatusB) {
      return isStatusB ? 1 : -1;
    }
  }

  return a.order - b.order;
}
